import { IEcosystem } from '../../common/tin-gpt/define-news';
import './style.ecosystem.scss';

interface Props {
    ecosystemItem: IEcosystem;
}

const Ecosystem = (props: Props) => {
    return (
        <div className='ecosystem-item'>
            <div className='image-ecosystem-item'>
                <img src={props.ecosystemItem.image} alt="" />
            </div>
            <div className='ecosystem-content'>
                <div className='title-ecosystem-item'>
                    {props.ecosystemItem.title}
                </div>
                <div className='description-ecosystem-item'>
                    {props.ecosystemItem.description}
                </div>
            </div>
        </div>
    )
}

export default Ecosystem
